/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Filled caret down icon (18px trim, used beside the settings gear)
 *
 * @file CaretDownFilledIcon.jsx
 * @author Gladson Samuel S
 * @since 3.1.0
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';

const CaretDownFilledIcon = ({ className, sx, ...props }) => (
  <SvgIcon
    {...props}
    className={className}
    viewBox="0 0 18 18"
    sx={{
      width: 18,
      height: 18,
      fontSize: 18,
      ...sx
    }}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M5.99434 6.5H12.0057C12.5548 6.5 13 6.94827 13 7.50124C13 7.76845 12.8939 8.02458 12.7054 8.21261L9.69972 11.2101C9.31219 11.5966 8.68781 11.5966 8.30028 11.2101L5.29463 8.21261C4.90445 7.82349 4.90142 7.18955 5.28786 6.79667C5.47461 6.60681 5.72897 6.5 5.99434 6.5Z" fill="currentColor" />
  </SvgIcon>
);

CaretDownFilledIcon.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

CaretDownFilledIcon.defaultProps = {
  className: undefined,
  sx: undefined
};

export default CaretDownFilledIcon;
